import { forwardRef } from "react";

import { appPriceStatusVariants } from "@/components/atoms/AppPriceStatus/constants";
import type { IAppPriceStatusProps } from "@/components/atoms/AppPriceStatus/types";
import { Paragraph } from "@/components/atoms/Paragraph";
import cn from "@/helpers/cn";
import { useTranslations } from "@/hooks/common/useTranslations";

const AppPriceStatus = forwardRef<HTMLDivElement, IAppPriceStatusProps>(
  ({ type, text, haveTrialDays, trialDays, className, ...props }, ref) => {
    const { t } = useTranslations("common");

    return (
      <div className="flex items-center gap-2">
        <div
          className={cn(appPriceStatusVariants({ type, className }))}
          ref={ref}
          {...props}
        >
          <Paragraph size="extraSmall" fontWeight="regular">
            {text}
          </Paragraph>
        </div>
        {haveTrialDays && (
          <Paragraph
            size="extraSmall"
            fontWeight="regular"
            type="secondary"
            className="text-[10px]"
          >
            {t("freeDaysTrial", {
              days: trialDays,
            })}
          </Paragraph>
        )}
      </div>
    );
  },
);

AppPriceStatus.displayName = "AppPriceStatus";

export default AppPriceStatus;
